var CartMultiGWP = (function(module, $) {
  'use strict';
  var urlToJson,
    checkParameters;
  var setCookie,
    getCookie,
    eraseCookie;


  function init_cart_slider() {
    $('.product-slider').slick({
      dots: false,
      infinite: true,
      autoplay: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      nextArrow: '<span class="slide-arrow arrow-next"><i class="fa fa-angle-right"></i></span>',
      prevArrow: '<span class="slide-arrow arrow-prev"><i class="fa fa-angle-left"></i></span>'
    });

    const slickData = $('.product-slider').slick('getSlick');

    if (slickData.slideCount > 0) {
      $('.cart-upsell').removeClass('hide');
    }
    console.log('Slick Test', $('.product-slider').slick('getSlick'));
  }

  function getCartPromise() {
    return new Promise(function(resolve, reject) {
      JM.MiniCart.getCart(function(cart) {
        resolve(cart);
      });
    });
  }


  const GWP = {
    state: {
      browsing_context: {},
      products: {},
      campaignData: JSON.parse(document.querySelector('[gwp-data]').innerHTML),
      selectedCampaign: null
    },

    getIndividualProduct: function(handle) {
      return fetch(`/products/${handle}.js`).then(function(response) {
        return response.json()
      }).catch(function(err) {
        console.warn('GWP Fetch Error', handle, err);
      });
    },

    getProducts: function() {
      const allHandles = GWP.state.campaignData.map(function(campaign) {
        return campaign.product;
      });

      const uniqueHandles = [...new Set(allHandles)];

      return Promise.all(uniqueHandles.map(GWP.getIndividualProduct)).then(function(response) {
        console.warn('Full Response', response, allHandles);
        response.forEach(async function(product) {
          if (! product) {
            return;
          }
          GWP.state.products[product.handle] = product;
        });
        return response;
      }).catch(function(err) {
        console.warn('Promise All error', err)
      });
    },

    checkRestrictions: function() {
      const campaigns = GWP.state.campaignData;
      const restrictedCampaigns = campaigns.filter(function(campaign) {
        return campaign.restrict
      });
      const parameters = urlToJson();

// if parameters don't exist, stop here.
      if (! parameters.campaign && ! getCookie('klaviyoGWP')) {
        const unRestrictedCampaigns = campaigns.filter(function(campaign) {
          return ! campaign.restrict
        });
        GWP.state.selectedCampaign = unRestrictedCampaigns[0];
        return;
      }

      if (getCookie('klaviyoGWP') && ! parameters.campaign) {
        const registeredCampaign = getCookie('klaviyoGWP');
        const correctCampaign = restrictedCampaigns.find(function(campaign) {
          return campaign.campaign === registeredCampaign
        });
        GWP.state.selectedCampaign = correctCampaign;
        return;
      }

// eraseCookie('klaviyoGWP');
// campaign.campaign === parameters.campaign
      const correctCampaign = restrictedCampaigns.find(function(campaign) {
        const tester = (parameters.campaign.toLowerCase().includes(campaign.campaign.toLowerCase()));
        return tester;
      });

      if (correctCampaign) {
        setCookie('klaviyoGWP', correctCampaign.campaign, 2);
        GWP.state.selectedCampaign = correctCampaign;
      }

      if (parameters.discount) {
        setCookie('klaviyoDiscount', parameters.discount, 2);
      }
    },

    getCart: function() {
      return fetch('/cart.js').then(function(response) {
        return response.json()
      }).catch(function(err) {
        console.warn('Get Cart Error', err)
      });
    },

    isThresholdMet: function(cart, campaign) {

      if (window.zonos && !window.zonos.isDomestic()) 
        returnfalse;
      


      const {items, items_subtotal_price} = cart;
      const {threshold_type, restrict} = campaign;
      const campaignGWP = GWP.state.products[campaign.product];
      const GWPInCart = items.find((item) => item.product_id === campaignGWP.id);
      const itemCount = (GWPInCart)
        ? items.length - 1
        : items.length;

      const itemCountExclusions = [...items].reduce((count, item) => {
        if (item.product_id === campaignGWP.id) 
          returncount;
        


        if (/(hoodie|parfum)/i.test(item.title)) 
          returncount;
        


        count += item.quantity;

        return count;
      }, 0);

      const subTotalNoExclusions = [...items].reduce((total, item) => {
        if (item.product_id === campaignGWP.id) 
          returntotal;
        


        if (/hoodie/i.test(item.title)) 
          returntotal;
        


        total += item.final_line_price;

        return total;

      }, 0);

      console.log('Checking Threshold', {subTotalNoExclusions, items, threshold_type, campaign});

      if (restrict) {
        const currentGWPCookie = getCookie('klaviyoGWP');

        if (currentGWPCookie !== campaign.campaign) {
          return false;
        }
      }

      console.log('THRESHOLD CHECK (Qualified)', threshold_type, cart, campaign.dollar_threshold * 100, subTotalNoExclusions, (campaign.dollar_threshold * 100) <= subTotalNoExclusions);

      if (threshold_type === 'item_count') {
        return campaign.item_count_threshold<= itemCountExclusions;
          }
      
          if (threshold_type === 'none') {
              return items.length> 0;
      }

      if (threshold_type === 'price') {
        return(campaign.dollar_threshold * 100) <= subTotalNoExclusions;
      }

    },

    addGWP: function(gift_product) {

// Domestic Customers only.
      if (window.zonos && !window.zonos.isDomestic()) return;
      


      const params = {
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: gift_product.variants[0].id,
          properties: {
            'GWP': 'Yes'
          }
        },
        dataType: 'json',
        success: function(cart) {
          let mql = window.matchMedia('(max-width: 768px)');
          console.log('GWP ADDED', cart);

// Reload Cart Page ( Instead of Updating Table ).
          if (location.pathname.indexOf('/cart') !== -1 || (mql && mql.matches)) {
            window.location.reload();
            return;
          } else {
            console.log('JM Cart Refresh');
            JM.MiniCart.getCart(function(cart) {
              JM.MiniCart.populateContainer(cart);

// window.reset_cart_drawer();

              init_cart_slider()
            });

// let cart = await getCartPromise();

// console.log('Update Nosto Cart', cart);

//
          }
        }
      }

      console.warn('Add GWP?', params, gift_product);

      $.ajax(params);
    },


    reduceGWPQuantity: function(cart, gwpProduct) {
      const items = cart.items.map((item, index) => {
        return {
          ...item,
          line: index + 1
        }
      });
      const GWPInCart = items.find((item) => item.product_id === gwpProduct.id);

      const params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + 1 + '&line=' + GWPInCart.line,
        dataType: 'json',
        success: function(cart) {
          if (location.pathname.indexOf('/cart') !== -1) {
            window.location.reload();
            return;
          }
          console.warn('Quantity Reduced', cart);
        }
      }

      $.ajax(params);
    },

    removeGiftProduct: function(cart, gwpProduct) {
      const items = cart.items.map((item, index) => {
        return {
          ...item,
          line: index + 1
        }
      });
      const GWPInCart = items.find((item) => item.product_id === gwpProduct.id);

// Reload Cart Page ( Instead of Updating Table ).
      if (location.pathname.indexOf('/cart') !== -1) {
        window.location = `/cart/change?line=${
          GWPInCart.line
        }&quantity=0`;
        return;
      }

      const params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + 0 + '&line=' + GWPInCart.line,
        dataType: 'json',
        success: function(cart) {
          GWP.removeFromDrawer(GWPInCart.line);
        }
      }

      $.ajax(params);
      console.log('Remove Gift Product', items, GWPInCart, {
        quantity: 0,
        line: GWPInCart.line
      });
    },

    removeFromDrawer: function(line) {
      const $line = $(`.cart-preview-product[data-line="${line}"]`);
      $line.remove();
    },

    addDiscount: function() {
      const discount = getCookie('klaviyoDiscount');
      const checkoutLinks = document.querySelectorAll('a[href="/checkout"]');

      if (! discount) return;
      


      checkoutLinks.forEach(function(link) {
        link.setAttribute('href', `/checkout?discount=${discount}`);
      });

      const checkoutForms = document.querySelectorAll('form[action="/cart"]');

      checkoutForms.forEach(function(form) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'discount';
        input.value = discount;
        form.appendChild(input);
      });
    },

    cartUpdate: async function() {
      const cart = await GWP.getCart();
      const items = cart.items;
      const userCampaign = getCookie('klaviyoGWP');
      const campaigns = GWP.state.campaignData;
      const unRestrictedCampaigns = campaigns.filter(function(campaign) {
        if (campaign.us_only) {
          return GWP.state.browsing_context.country_name === 'United States'
        }

        return ! campaign.restrict
      });
      console.warn('Cart Update CART', GWP.state, cart, unRestrictedCampaigns);

// if (!userCampaign && unRestrictedCampaigns.length === 0) {
// return;
// }

      const runningCampaign = (userCampaign)
        ? userCampaign
        : unRestrictedCampaigns[0];

      const storeQualifyingCampaign = GWP.state.campaignData.find(function(campaign) {
        return campaign.id === GWP.state.selectedCampaign ?. id
      });
      console.log('Running Campaign', userCampaign, unRestrictedCampaigns, runningCampaign, storeQualifyingCampaign);
      if (! storeQualifyingCampaign) return;
      


      const campaignGWP = GWP.state.products[storeQualifyingCampaign.product];


      const GWPInCart = items.find((item) => item.product_id === campaignGWP.id);

// Item in cart already. Exit Function
      console.log('Cart Update?', GWPInCart);
      if (GWPInCart) {

        if (! GWP.isThresholdMet(cart, storeQualifyingCampaign)) {
          GWP.removeGiftProduct(cart, campaignGWP);
        }

        console.warn('HOW MANY IN CART', GWP.isThresholdMet(cart, storeQualifyingCampaign), GWPInCart.quantity);
        if (GWPInCart.quantity > 1) {
          GWP.reduceGWPQuantity(cart, campaignGWP);
        }

        GWP.addDiscount();

        return;
      }

      console.log('Cart Update?', GWP.isThresholdMet(cart, storeQualifyingCampaign), ! GWPInCart, getCookie('klaviyoGWPSubmitted') !== 'true', {
        result: GWP.isThresholdMet(cart, storeQualifyingCampaign) && ! GWPInCart && getCookie('klaviyoGWPSubmitted') !== 'true'
      });

      if (GWP.isThresholdMet(cart, storeQualifyingCampaign) && ! GWPInCart && getCookie('klaviyoGWPSubmitted') !== 'true') {
        GWP.addGWP(campaignGWP);
      }
    },

    getBrowsingContext: async function() {
      const {detected_values} = await fetch('/browsing_context_suggestions.json').then((res) => res.json())

      GWP.state.browsing_context = {
        ...detected_values
      }

    },

    init: async function() {
      console.warn('Multi GWP Init', GWP.state, this);
      await GWP.getBrowsingContext()
      await GWP.getProducts();
      GWP.checkRestrictions();
      GWP.cartUpdate();

      document.querySelectorAll('form[action="/cart/add"] button[type="submit"]').forEach(function($btn) {
        $btn.addEventListener('click', function() {
          setTimeout(function() {
            GWP.cartUpdate();
          }, 500);
        });
      });
    }
  };

  eraseCookie = (cookieKey) => {
    document.cookie = cookieKey + '=; Max-Age=-99999999;';
  };

  urlToJson = (url = location.search) => {
    var query = url.substr(1);
    var result = {};
    query.split("&").forEach(function(part) {
      var item = part.split("=");
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
  };

  checkParameters = () => {
    const {
      klaviyo: {
        restrict,
        campaign,
        cookie
      }
    } = settings;
    const parameters = urlToJson();

    console.warn('Check url Parameters', parameters, getCookie('klaviyoDiscount'));

// if parameters don't exist, stop here.
    if (! parameters.campaign) {
      return;
    }

// eraseCookie('klaviyoGWP');
    const correctCampaign = (parameters.campaign === campaign);
    const currentGWPCookie = getCookie('klaviyoGWP');

    if (correctCampaign && currentGWPCookie !== campaign) {
      setCookie('klaviyoGWP', campaign);
    }

    console.log('Set Discount', parameters.discount);
    if (parameters.discount) {
      setCookie('klaviyoDiscount', parameters.discount);
    }
  };

  setCookie = (cookieKey, cookieValue, expirationDays) => {
    let expiryDate = '';

    if (expirationDays) {
      const date = new Date();

      date.setTime(`${
        date.getTime()
      }${
        (expirationDays || 30 * 24 * 60 * 60 * 1000)
      }`);

      expiryDate = `; expiryDate=" ${
        date.toUTCString()
      }`;
    }

    document.cookie = `${cookieKey}=${
      cookieValue || ''
    }${expiryDate}; path=/`;
  };

  getCookie = (cookieKey) => {
    let cookieName = `${cookieKey}=`;

    let cookieArray = document.cookie.split(';');

    for (let cookie of cookieArray) {

      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1, cookie.length);
      }

      if (cookie.indexOf(cookieName) == 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
  };

  module = {
    init: GWP.init
  };

  return module;

}(CartMultiGWP || {}, jQuery));